// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"125":"b16055cf","234":"6ef55ebb","353":"33b60870"}[chunkId] + ".js";
};